module.exports = __webpack_public_path__ + "static/media/kategorija.6c4a6e26.svg";